<template>
  <v-bottom-sheet 
    :value="show"
    persistent
    :inset="$vuetify.breakpoint.mdAndUp"
    scrollable
    :style="{'height':height + 'px'}"
  >

    <v-card color="white">
      <v-card-text class="pa-0">
        <v-container fluid style="position: relative;">
          <v-btn small text style="position: absolute; top: 15px; right: 15px;" @click="close()" :disabled="saving">Close</v-btn>
          <v-row>
            <v-col class="title text-center">Edit Debt</v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col
              md="4"
              lg="3"
            >
              <v-text-field
                v-model="name"
                outlined
                dense
                hide-details
                label="Name"
                :disabled="saving"
              />
            </v-col>
            <v-col
              md="4"
              lg="3"
            >
              <v-select
                v-model="type"
                :items="types"
                outlined
                dense
                hide-details
                label="Type"
                :disabled="saving"
              />
            </v-col>

            <v-col
              md="4"
              lg="3"
            >
              <v-text-field
                v-model="interest_rate"
                outlined
                dense
                hide-details
                label="Interest Rate"
                :disabled="saving"
              />
            </v-col>
          </v-row>

          <v-divider class="my-4" />
          <div class="text-center title">Balance Details</div>
          <v-row class="justify-center">
            <v-col
              md="8"
              lg="6"
            >
              <v-text-field
                v-model="balance"
                outlined
                dense
                hide-details
                label="Balance"
                :disabled="saving"
              />
            </v-col>
            <v-col
              md="4"
              lg="3"
            >
              <v-menu
                ref="balanceAsOfMenu"
                v-model="balanceAsOfMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="balance_as_of_formatted"
                    dense
                    outlined
                    label="Balance As Of"
                    placeholder="Choose..."
                    v-bind="attrs"
                    v-on="on"
                    @blur="balance_as_of = parseDate(balance_as_of_formatted)"
                    :disabled="saving"
                  />
                </template>
                <v-date-picker v-model="balance_as_of" no-title scrollable @input="balanceAsOfMenu = false" type="month" />
              </v-menu>
            </v-col>
          </v-row>
          <v-divider class="my-4" />
          <div class="text-center title">Payments</div>
          <v-row class="justify-center">
            <v-col
              md="6"
              lg="4"
            >
              <v-text-field
                v-model="minimum_payment"
                outlined
                dense
                hide-details
                label="Minimum Payment"
                :disabled="saving"
              />
            </v-col>
            <v-col
              md="6"
              lg="4"
            >
              <v-text-field
                v-model="actual_payment"
                outlined
                dense
                hide-details
                label="Actual Payment"
                :disabled="saving"
              />
            </v-col>
          </v-row>

          <v-row class="mt-6 justify-center">
            <v-col class="text-center">
              <v-btn large color="primary" @click="saveDebt" :loading="saving">Save</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>

</template>

<script>
export default {
  name: 'DebtSheet',
  props: {
    household: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      forceShow: false,
      tempDebt: null,

      name: null,
      type: null,
      cardType: null,
      balance: null,
      balance_as_of: null,
      balance_as_of_formatted: null,
      minimum_payment: null,
      actual_payment: null,
      interest_rate: null,

      interest_only: false,
      loan_months: null,
      interest_only_months: null,
      loan_start_date: null,
      loan_start_date_formatted: null,
      loan_start_balance: null,

      debtStartMenu: false,
      balanceAsOfMenu: false,

      saving: false
    }
  },
  mounted () {
    this.reset()
  },
  watch: {
    show(newVal) {
      if(newVal) this.reset()
    },
    loan_start_date ( newVal ) {
      this.loan_start_date_formatted = this.formatDate( newVal )
    },
    balance_as_of ( newVal ) {
      this.balance_as_of_formatted = this.formatDate( newVal )
    }
  },
  computed: {
    show() {
      return this.forceShow || (this.$route.name == 'households-debts' && this.$route.params.debt_action == 'edit' && this.$route.params.debt_id)
    },
    height() {
      if(this.$vuetify.breakpoint.smAndDown) return window.innerHeight
      return window.innerHeight - 40
    },
    types() {
      return [
        {
          text: 'Mortgage',
          value: 'mortgage'
        },
        {
          text: 'Credit',
          value: 'credit'
        },
        {
          text: 'Auto',
          value: 'auto'
        },
        {
          text: 'Other',
          value: 'other'
        }
      ]
    },
    debtId() {
      return (this.tempDebt ? this.tempDebt.id : this.$route.params.debt_id)
    }
  },
  methods: {
    close () {
      this.tempDebt = null
      if(this.forceShow) {
        this.forceShow = false
      } else {
        this.$router.push({params:{debt_id: null, debt_action: null}})
      }
    },
    open (debt) {
      this.tempDebt   = debt
      this.forceShow  = true
    },
    reset () {
      if(!this.forceShow) {
        this.household.debts.forEach(d => {
          if(d.id == this.$route.params.debt_id) this.tempDebt = d
        })
        if(!this.tempDebt) return
      }
      this.name                     = this.tempDebt.name
      this.type                     = this.tempDebt.type
      this.cardType                 = this.tempDebt.card_type
      this.balance                  = this.tempDebt.balance
      this.balance_as_of            = this.$moment(this.tempDebt.balance_as_of).format('YYYY-MM')
      this.minimum_payment          = parseInt(this.tempDebt.minimum_payment)
      this.actual_payment           = parseInt(this.tempDebt.actual_payment) || parseInt(this.tempDebt.minimum_payment)
      this.interest_rate            = this.tempDebt.interest_rate
      this.interest_only            = (this.tempDebt.interest_only ? true : false)
      this.loan_start_date          = this.tempDebt.loan_start_date
      this.loan_months              = this.tempDebt.loan_months
      this.interest_only_months     = this.tempDebt.interest_only_months

      this.saving                   = false
    },
    saveDebt () {
      this.saving = true;
      let balAsOf = (this.balance_as_of ? this.balance_as_of + '-05' : this.$moment().format('YYYY-MM') + '-05')
      let data = {
        name:                 this.name,
        type:                 this.type,
        balance:              this.balance,
        balance_as_of:        balAsOf,
        minimum_payment:      this.minimum_payment,
        actual_payment:       (this.actual_payment || null),
        interest_rate:        this.interest_rate,
        //interest_only:        (this.interest_only ? 1 : 0),
        //loan_months:          (this.interest_only ? this.loan_months : null),
        //interest_only_months: (this.interest_only ? this.interest_only_months : null),
        //start_date:           (this.interest_only ? this.loan_start_date + '-05' : null)
      }
      this.$http.put('debts/' + this.debtId + '?expand=amortizationSchedule', data)
        .then(response => {
          if(response.data.alteredPlans) this.$emit('on-plans-altered')
          this.$emit('on-save', response.data)
          console.log('should fire close')
          this.close()
        })
        .catch(err => {
          if(err.response.status == 401) return
          
          let message = ''
          if(err.response.status == 422) {
            message = ':<br><br>'
            for(let i = 0; i < err.response.data.length; i++) {
              message += '<b>' + err.response.data[i].message + '</b><br>'
            }
          }
          console.log('Debt Error: ', err.response);
          this.$swal.fire({
            title: 'Error', 
            html: 'There was an issue saving the debt' + message, 
            type: 'error'
          });
        })
        .finally(() => {
          this.saving = false;
        })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      let [month, year, year2] = date.split('/')
      if(year2) year = year2
      return `${year}-${month.padStart(2, '0')}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .darkButtonPrimary {
    ::v-deep .v-btn__content {
      ::v-deep i {
        color: #FFF !important;
      }
      color: #FFF !important;
    }
  }

  .debtButton {
    padding: unset !important;
    padding-top: 100% !important;
    height: unset !important;
    min-height: unset !important;
    max-height: unset !important;
    position: relative;
    width: 100% !important;
    ::v-deep i {
      font-size: 50px;
      margin-bottom: 5px;
    }
    ::v-deep .v-btn__content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      flex-direction: column;
    }
  }
</style>